function PopOutModal(triggerEl) {
    this.triggerEl = triggerEl;
    this.modalId = triggerEl.getAttribute('aria-controls');
    this.modal = this.modalId ? document.getElementById(this.modalId) : null;
    this.focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.previousActiveElement = null;
    this.isOpen = false;

    if (!this.modal) return;

    this.addEventListeners();
}

PopOutModal.prototype = {
    addEventListeners: function() {
        this.triggerEl.addEventListener('click', this.open.bind(this));
        this.triggerEl.addEventListener('keydown', this.handleTriggerKeyDown.bind(this));

        this.modal.addEventListener('click', e => {
            if (e.target === this.modal || e.target.classList.contains('jsClosePopOut')) {
                e.preventDefault();
                this.close();
            }
        });

        this.modal.addEventListener('keydown', this.handleFocusTrap.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    },

    getFocusableElements: function() {
        return Array.prototype.slice.call(this.modal.querySelectorAll(this.focusableSelector)).filter(el => {
            return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
        });
    },

    open: function(e) {
        if (e) e.preventDefault();
        if (this.isOpen || !this.modal) return;

        this.previousActiveElement = document.activeElement;
        this.modal.hidden = false;
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-modal-open');
        this.isOpen = true;

        const focusableElements = this.getFocusableElements();
        this.firstFocusableElement = focusableElements[0] || this.modal;
        this.lastFocusableElement = focusableElements[focusableElements.length - 1] || this.modal;

        const closeBtn = this.modal.querySelector('.pop-out-modal__close');
        if (closeBtn) closeBtn.focus();
        else this.firstFocusableElement.focus();
    },

    close: function() {
        if (!this.isOpen || !this.modal) return;

        this.modal.hidden = true;
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-modal-open');
        this.isOpen = false;

        if (this.previousActiveElement && typeof this.previousActiveElement.focus === 'function') {
            this.previousActiveElement.focus();
        }
        else {
            this.triggerEl.focus();
        }
    },

    handleFocusTrap: function(e) {
        if (!this.isOpen || e.key !== 'Tab') return;

        const focusableElements = this.getFocusableElements();
        if (!focusableElements.length) {
            e.preventDefault();
            this.modal.focus();
            return;
        }

        this.firstFocusableElement = focusableElements[0];
        this.lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableElement) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    },

    handleTriggerKeyDown: function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.open(e);
        }
    },

    handleKeyDown: function(e) {
        if (e.key === 'Escape' && this.isOpen) this.close();
    }
};

(function() {
    const triggers = document.querySelectorAll('.jsPopOutTrigger');
    triggers.forEach(el => new PopOutModal(el));
})();
